import update from 'immutability-helper'
import React from 'react'
import Box from '@mui/material/Box'
import {faEdit} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import EditableCaption from './editable-caption'
import {createPost} from '../../../helpers/command'

export default function QuestionTitle(props) {
  const {context, className, question} = props
  const {translate} = context
  const [editingTitle, setEditingTitle] = React.useState(false)
  const {properties = {}} = question

  function onEditTitleClick () {
    setEditingTitle(true)
  }

  function closeEditTitle() {
    setEditingTitle(false)
  }

  async function handleRetitle(title) {
    const id = question.id
    if (properties.title != title) {
      props.updateProperties && props.updateProperties({id, properties: {title}}, {properties: {title: {$set: title}}})
    }
  }

  const title = properties.title || translate('question')

  return (<Box className={className} onClick={onEditTitleClick}>
    <Box className="input">
      <EditableCaption
        editing={editingTitle}
        value={title}
        onCancel={closeEditTitle}
        onConfirm={title => handleRetitle(title) && closeEditTitle()}
        className="inputTitle"
      />
    </Box>
    {!editingTitle &&
    <Box className="icon">
      <FontAwesomeIcon icon={faEdit} />
    </Box>}
  </Box>)
}

